var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var File = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#153255' : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ version: "1.0", viewBox: "0 0 234 210", height: "75px", width: "63px", fill: color, xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { transform: "translate(0 210) scale(.1 -.1)" },
            React.createElement("path", { d: "m655 2007c-201-67-323-257-287-449 24-126 104-238 210-292l51-26 3-422c3-385 5-425 21-449 9-14 29-31 43-37 18-9 182-12 580-12h556l68 68v484 484l-396 394h-180-179l-28 54c-37 70-121 150-193 183-69 31-204 41-269 20zm240-91c72-33 129-87 162-154 24-49 28-69 28-142 0-74-4-93-29-143-58-114-167-181-296-181-98 0-168 33-238 109-60 66-82 124-82 219 0 57 6 83 29 131 29 61 93 130 150 159 79 41 189 42 276 2zm565-419c0-121 4-177 12-185s64-12 185-12h173v-443c0-331-3-446-12-455-17-17-1079-17-1096 0-9 9-12 115-12 414v401l73 5c102 8 176 39 247 105 82 76 122 157 128 264l5 79h148 149v-173zm200-2 115-115h-123-122v115c0 63 3 115 8 115 4 0 59-52 122-115z" }),
            React.createElement("path", { d: "m711 1786c-28-36-51-70-51-76 0-5 14-10 30-10h30v-76-75l43 3 42 3 3 73 3 72h29c17 0 30 4 30 8 0 7-77 112-99 135-5 5-31-21-60-57z" }),
            React.createElement("path", { d: "m591 1491c-7-13-7-23 2-35 11-14 32-16 171-14 133 3 160 6 169 19 6 9 7 24 4 33-6 14-28 16-171 16-151 0-166-2-175-19z" }),
            React.createElement("path", { d: "m1490 1133c-51-20-76-70-60-119 14-43 44-64 90-64 89 0 129 103 63 162-21 20-70 30-93 21z" }),
            React.createElement("path", { d: "m1136 987c-19-15-256-397-256-413 0-32 26-34 396-32l369 3 3 22c3 21-104 187-161 251-27 29-40 28-80-8-19-16-43-30-54-30-12 0-45 36-96 104-43 57-84 106-91 109-8 3-21 0-30-6z" }))));
};
export default File;
//# sourceMappingURL=File.js.map